module.exports = __webpack_public_path__ + "static/media/picklist-settings-icon.d2074c23.svg";